/**
 * @generated SignedSource<<7c1a0f4d990a4ecadb2212881df70bd9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LinkAccountQuery$variables = {
  token: string;
};
export type LinkAccountQuery$data = {
  readonly oauthLinkActivation: {
    readonly email: string | null | undefined;
    readonly oauthProvider: {
      readonly email: string;
      readonly provider: string;
    };
  } | null | undefined;
};
export type LinkAccountQuery = {
  response: LinkAccountQuery$data;
  variables: LinkAccountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkAccountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "OauthLinkActivation",
        "kind": "LinkedField",
        "name": "oauthLinkActivation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OauthProvider",
            "kind": "LinkedField",
            "name": "oauthProvider",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LinkAccountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "OauthLinkActivation",
        "kind": "LinkedField",
        "name": "oauthLinkActivation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OauthProvider",
            "kind": "LinkedField",
            "name": "oauthProvider",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90499ac54e9c84da61917e7d6978c453",
    "id": null,
    "metadata": {},
    "name": "LinkAccountQuery",
    "operationKind": "query",
    "text": "query LinkAccountQuery(\n  $token: String!\n) {\n  oauthLinkActivation(token: $token) {\n    email\n    oauthProvider {\n      email\n      provider\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e4763060f5dca66ede9e37c819ac684";

export default node;
